// services/apiMaestroConsecutivos.js
import ValidacionesConsecutivos from '../components/utils/ValidacionesConsecutivos';
const API_MAESTRO_CONSECUTIVO = 'https://www.ancogenecop.com/APIANCO/controllers/maestroConsecutivos.php?op=';

export const obtenerConsecutivos = async () => {
    const data = new FormData();
    try {
        const response = await fetch(API_MAESTRO_CONSECUTIVO + 'maestroConsecutivos', {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        console.error('Error al obtener los consecutivos:', error);
        return [];
    }
};

export const guardarConsecutivo = async (product,toastRef, enviar) => {
    const esValido = ValidacionesConsecutivos.validarCamposRequeridos(product, toastRef, enviar);
    if (!esValido) return 0;
    const data = new FormData();
    data.append("id", product.id);
    data.append("codigo", product.codigo);
    data.append("nid_propietario", product.nid_propietario);
    data.append("numero", product.numero);
    data.append("estado", product.estado);

    try {
        const response = await fetch(API_MAESTRO_CONSECUTIVO + 'ingresarConsecutvo', {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        console.error('Error al guardar el consecutivo:', error);
        return 0;
    }
};

export const eliminarConsecutivo = async (id, numero) => {
    const data = new FormData();
    data.append("id", id);
    data.append("numero", numero);

    try {
        const response = await fetch(API_MAESTRO_CONSECUTIVO + 'eliminarConsecutivo', {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        console.error('Error al eliminar el consecutivo:', error);
        return 0;
    }
};
 
export const obtenerDetalleConsecutivo = async (nid_propietario, numero,codigo) => {
    //console.log(nid_propietario,numero,codigo)
    const data = new FormData();
    data.append("nid_propietario", nid_propietario);
    data.append("numero", numero);
    data.append("codigo", codigo);

    try {
        const response = await fetch(API_MAESTRO_CONSECUTIVO + 'detalleConsecutivo', {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        console.error('Error al obtener el detalle del consecutivo:', error);
        return [];
    }
};
